export default __webpack_public_path__ + "static/media/Josh_Hoover.c5a01895.jpg";